import { FC, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { FaqTitle, FaqDescription, FaqWrapper } from './FAQ.styles';
import { FaqSingular, FaqCollection } from './FAQ.types';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '../../../ContentfulRenderOptions';
import { Accordion } from '@zoopla-eng/zds-components/accordion';
import Script from 'next/script';
import { constructGoogleFaqSchema } from '../../../functions/constructGoogleFaqSchema';

export const FAQComponent: FC<FaqCollection> = ({
    description,
    title,
    faqs,
    injectSchema = false
}) => {
    const [value, updateValue] = useState<string[]>([]);

    // convert singular FAQ object to array for types.
    const faqToArr = !Array.isArray(faqs) ? [faqs] : faqs;

    const faqToPanel = (faqs: FaqSingular[]) =>
        faqs.map((faq, index) => ({
            label: faq.question,
            value: `${index + 1}`,
            component: (
                <>
                    {documentToReactComponents(
                        faq.answer,
                        CONTENTFUL_RICH_TEXT_OPTIONS
                    )}
                </>
            )
        }));

    return (
        <>
            {injectSchema && (
                <Script type="application/ld+json" id="faqSchema">
                    {constructGoogleFaqSchema(faqToArr)}
                </Script>
            )}
            <FaqWrapper className="FAQ">
                {title && <FaqTitle>{title}</FaqTitle>}
                {description && <FaqDescription>{description}</FaqDescription>}
                <Accordion
                    value={value}
                    onValueChange={updateValue}
                    panels={faqToPanel(faqToArr)}
                    maxWidth="100%"
                />
            </FaqWrapper>
        </>
    );
};
